import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { DICTIONARY } from '../../../constants/dictionary'
import { Entry } from '../../../model/Entry'
import { iGen } from '../../../utils/indexGen'
import { pdfDocStyles } from '../PDFDocument'

interface Props {
  optionDetails: Entry[]
  parentStyles: typeof pdfDocStyles
}

const OptionDetailsSection: React.FC<Props> = ({
  optionDetails,
  parentStyles,
}) => {
  const { t } = useTranslation()
  return (
    !!optionDetails.length && (
      <View wrap={false}>
        <Text style={parentStyles.subTitle}>
          {t(DICTIONARY.QUOTE_SUMMARY_PACKS_AND_OPTIONS_LABEL)}
        </Text>
        {optionDetails.map((optionDetail, index) => (
          <View style={parentStyles.row} key={iGen(index)}>
            <Text style={parentStyles.halfDescription}>
              {optionDetail.description}
            </Text>
            <Text style={parentStyles.quarter} />
            <Text style={parentStyles.value}>{optionDetail.value}</Text>
          </View>
        ))}
      </View>
    )
  )
}

export default OptionDetailsSection
